import { enableSelfServiceEnterpriseTrials } from '@gonfalon/dogfood-flags/dogfood-flags';

import { daysRemaining } from './daysRemaining';
import { hasBeenStarted } from './hasBeenStarted';
import type { CampaignType } from './types';

export function isActive(campaign: CampaignType) {
  return enableSelfServiceEnterpriseTrials() && hasBeenStarted(campaign) && daysRemaining(campaign) > 0;
}
